import { createSlice } from '@reduxjs/toolkit';
import { type MakeModelDetails } from 'types/makeModel.types';

export type InitialStateType = MakeModelDetails[];

const initialState: InitialStateType = [];

export const makeModelDetailsSlice = createSlice({
  name: 'makeModelDetails',
  initialState,
  reducers: {
    setMakeModelDetails(state, { payload }) {
      return payload;
    },
  },
});

export const { setMakeModelDetails } = makeModelDetailsSlice.actions;
export default makeModelDetailsSlice.reducer;
